import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

export const DrawerGenericExportWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "drawer-generic-export-wrapper",
  },
)`
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: stretch;

  .export-format-toggle {
    display: inline-flex;
    align-self: flex-start;
    border-radius: 8px;
    border: 1px solid ${greyMui._300};
    padding: 2px;
    background: ${rydeColors.white};
  }

  .export-format-toggle__button {
    appearance: none;
    border: none;
    cursor: pointer;
    padding: 6px 16px;
    min-width: 72px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 6px;
    background: transparent;
    color: ${greyMui._700};
    transition:
      background 0.15s ease,
      color 0.15s ease;

    &[aria-checked="true"] {
      background: ${rydeColors.vividPurple};
      color: ${rydeColors.white};
    }

    &:focus-visible {
      outline: 2px solid ${rydeColors.princetonPurple};
      outline-offset: 2px;
    }
  }
`;
